import { theme } from '../../../styleguide'

export const getCardInfo = {
  TM: { title: 'Mantenimiento', theme: theme.cards.tm },
  TO: { title: 'Orden y Limpieza', theme: theme.cards.to },
  TQ: { title: 'Calidad', theme: theme.cards.tq },
  TS: { title: 'Seguridad', theme: theme.cards.ts },
}
